/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locales_Pt_PtInputs */

const en_us2_locales_pt_pt = /** @type {(inputs: Locales_Pt_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português (Portugal)`)
};

const pt_br2_locales_pt_pt = /** @type {(inputs: Locales_Pt_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português (Portugal)`)
};

const es_419_locales_pt_pt = /** @type {(inputs: Locales_Pt_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português (Portugal)`)
};

const pt_pt2_locales_pt_pt = /** @type {(inputs: Locales_Pt_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português (Portugal)`)
};

const fr_fr2_locales_pt_pt = /** @type {(inputs: Locales_Pt_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português (Portugal)`)
};

const de_de2_locales_pt_pt = /** @type {(inputs: Locales_Pt_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português (Portugal)`)
};

const it_it2_locales_pt_pt = /** @type {(inputs: Locales_Pt_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português (Portugal)`)
};

/**
* | output |
* | --- |
* | "Português (Portugal)" |
*
* @param {Locales_Pt_PtInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const locales_pt_pt = /** @type {((inputs?: Locales_Pt_PtInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locales_Pt_PtInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_locales_pt_pt(inputs)
	if (locale === "es-419") return es_419_locales_pt_pt(inputs)
	if (locale === "pt-PT") return pt_pt2_locales_pt_pt(inputs)
	if (locale === "fr-FR") return fr_fr2_locales_pt_pt(inputs)
	if (locale === "de-DE") return de_de2_locales_pt_pt(inputs)
	if (locale === "it-IT") return it_it2_locales_pt_pt(inputs)
	return en_us2_locales_pt_pt(inputs)
});
export { locales_pt_pt as "locales.pt_pt" }